import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { environment } from "../../environments/environment";
import { EncryptDecryptService } from "../encrypt-decrypt.service";

@Injectable({
  providedIn: "root",
})
export class ContactUsService {
  private headerObj: object;
  private httpOptions;
  videoCdnUrl = environment.googleCDNUrl;

  constructor(
    private http: HttpClient,
    private encDecService: EncryptDecryptService
  ) {}

  EmailUs(emailData) {
    return this.http.post(
      environment.configUrl + "ContactUS/ContactUs?CurrentDate=" + new Date(),
      emailData
    );
  }

  ContactRequestForm(emailData) {
    return this.http.post(
      environment.configUrl +
        "ContactUS/ContactRequestForm?CurrentDate=" +
        new Date(),
      emailData
    );
  }

  EmergencyContact(emailData) {
    return this.http.post(
      environment.configUrl +
        "ContactUS/EmergencyContactUs?CurrentDate=" +
        new Date(),
      emailData
    );
  }

  GetReasons() {
    return this.http.get(
      environment.configUrl + "Appointment/GetReasons?CurrentDate=" + new Date()
    );
  }

  GetProvidersByReasonID(ReasonID) {
    return this.http.get(
      environment.configUrl +
        "Appointment/GetStaffDetailsByReasonID?ReasonID=" +
        ReasonID +
        "&CurrentDate=" +
        new Date()
    );
  }

  // GetAppointmentScheduleByStaffID(StaffID, NHSFlag) {
  // return this.http.get(environment.configUrl + 'Appointment/GetAppointmentScheduleByStaffID?StaffID=' + StaffID + '&NHSFlag=' + NHSFlag + '&CurrentDate=' + new Date())
  // }

  GetAppointmentScheduleByStaffID(StaffID, ReasonID) {
    return this.http.get(
      environment.configUrl +
        "Appointment/GetAppointmentScheduleByStaffID?StaffID=" +
        this.encDecService.enc(StaffID.toString()) +
        "&ReasonID=" +
        this.encDecService.enc(ReasonID.toString()) +
        "&CurrentDate=" +
        new Date()
    );
  }
  DeleteUnconfirmedSlots(PatientID)
  {
    return this.http.get(
      environment.configUrl + "Appointment/DeleteUnconfirmedSlots?PatientID= " + PatientID
    );
  }

  InsertPatientsAndSlot(PatientDetails, AppointmentDocuments) {
    this.headerObj = new HttpHeaders({
      ContentType: null,
      Accept: "multipart/form-data",
    });
    this.httpOptions = {
      headers: this.headerObj,
    };
    return this.http.post(
      environment.configUrl +
        "Appointment/InsertPatientsAndSlot?PatientDetails=" +
        this.encDecService.enc(JSON.stringify(PatientDetails)) +
        "&CurrentDate=" +
        new Date(),
      AppointmentDocuments
    );
  }

  InsertJobOpportunity(JobSeekerDetails, CVDocuments) {
    this.headerObj = new HttpHeaders({
      ContentType: null,
      Accept: "multipart/form-data",
    });
    this.httpOptions = {
      headers: this.headerObj,
    };
    return this.http.post(
      environment.configUrl +
        "JobOpportunity/InsertJobOpportunity?Data=" +
        this.encDecService.enc(JSON.stringify(JobSeekerDetails)) +
        "&CurrentDate=" +
        new Date(),
      CVDocuments
    );
  }

  GetFaqs() {
    return this.http.get("../assets/Data/FAQs.json?currenDate=" + new Date());
  }

  GetGlossary() {
    return this.http.get(
      "../assets/Data/SmileGlossary.json?currenDate=" + new Date()
    );
  }

  AppointmentEmails(emailData) {
    var Data = {
      AppointmentEmailData: this.encDecService.enc(JSON.stringify(emailData)),
    };
    return this.http.post(
      environment.configUrl +
        "ContactUS/AppointmentEmails?CurrentDate=" +
        new Date(),
      Data
    );
  }

  MembershipEmails(emailData) {
    var Data = {
      MembershipEmailData: this.encDecService.enc(JSON.stringify(emailData)),
    };
    return this.http.post(
      environment.configUrl +
        "ContactUS/MembershipEmails?CurrentDate=" +
        new Date(),
      Data
    );
  }

  GetMembershipPlanDetailsByPlanID(PlanID) {
    return this.http.get(
      environment.configUrl +
        "Membership/GetMembershipPlanDetailsByPlanID?PlanID=" +
        PlanID +
        "&CurrentDate=" +
        new Date()
    );
  }

  GenerateAppointmentEmails(AppointmentScheduleSlotLevelID) {
    return this.http.get(
      environment.configUrl +
        "Appointment/GenerateAppointmentEmails?AppointmentScheduleSlotLevelID=" +
        this.encDecService.enc(AppointmentScheduleSlotLevelID.toString()) +
        "&CurrentDate=" +
        new Date()
    );
  }

  GetStaffWithAppointmentTransferPermission() {
    return this.http.get<any>(
      `${environment.configUrl}Appointment/GetStaffWithAppointmentTransferPermissionForPatient?CurrentDate=` +
        new Date()
    );
  }

  GetAllStaffSockets() {
    return this.http.get<any>(
      `${environment.configUrl}Staff/GetAllStaffSockets?CurrentDate=` +
        new Date()
    );
  }
}
